import React from 'react';

/**
 * TechStack.jsx — "Our technology stack". Self-contained, beige theme.
 * Sits between Features and WhyWorkWithUs.
 *
 * Category label + dot colour use olive (#5E6B39); cards follow the same
 * white/radius-20 language as UseCases and Features.
 */
const STACK = [
  {
    label: 'AI Models',
    items: ['OpenAI', 'Anthropic Claude', 'Google Gemini', 'Azure OpenAI'],
  },
  {
    label: 'Automation',
    items: [
      'n8n',
      'Make',
      'Zapier',
      'Power Automate',
      'Blue Prism',
      'HighLevel',
      'Lovable',
    ],
  },
  {
    label: 'Communication',
    items: ['Outlook', 'Gmail', 'WhatsApp', 'Slack & Teams', 'SMS & Voice'],
  },
  {
    label: 'Cloud & Data',
    items: ['AWS', 'Azure', 'Google Cloud', 'MongoDB'],
  },
];

const TechStack = () => (
  <section id="tech-stack" className="cai-ts">
    <div className="cai-ts-inner">
      <div className="cai-ts-head">
        <h2 className="cai-ts-h2">Our technology stack</h2>
        <p className="cai-ts-sub">
          The platforms we build on and integrate with, selected to fit your operations rather than
          a fixed template.
        </p>
      </div>

      <div className="cai-ts-grid">
        {STACK.map((group) => (
          <div key={group.label} className="cai-ts-card">
            <div className="cai-ts-label">{group.label}</div>
            <ul className="cai-ts-list">
              {group.items.map((item) => (
                <li key={item}><span className="cai-ts-dot" />{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <p className="cai-ts-note">
        <span className="cai-ts-note-dot" />
        <span>
          <b>Deployment is your decision.</b> Run the stack in-house with your own team, or hand it
          to us to build, host and manage end to end. Either way your data stays inside your
          environment — never shared with third parties, and never used to train AI models.
        </span>
      </p>
    </div>

    <style>{`
      .cai-ts { background: #ECEAE3; padding: 96px 40px 96px; }
      .cai-ts-inner { max-width: 1200px; margin: 0 auto; }
      .cai-ts-head { text-align: center; max-width: 760px; margin: 0 auto 48px; }
      .cai-ts-h2 { font-size: 42px; font-weight: 800; letter-spacing: -0.025em; margin: 0; line-height: 1.1; color: #1A1A18; }
      .cai-ts-sub { font-size: 18px; line-height: 1.55; color: #5A564D; margin: 18px 0 0; }
      .cai-ts-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 22px; align-items: stretch; }
      .cai-ts-card { background: #fff; border-radius: 20px; padding: 28px 26px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); }
      .cai-ts-label { font-size: 11.5px; font-weight: 700; letter-spacing: 0.11em; text-transform: uppercase; color: #5E6B39; margin-bottom: 16px; }
      .cai-ts-list { list-style: none; margin: 0; padding: 0; }
      .cai-ts-list li { display: flex; align-items: center; gap: 10px; font-size: 15px; line-height: 1.5; color: #3A3730; padding: 7px 0; }
      .cai-ts-dot { flex-shrink: 0; width: 5px; height: 5px; border-radius: 50%; background: #5E6B39; display: block; }
      .cai-ts-note { display: flex; align-items: flex-start; gap: 12px; max-width: 820px; margin: 36px auto 0; background: #EAEDE2; border-radius: 16px; padding: 20px 24px; font-size: 15.5px; line-height: 1.6; color: #3F4726; }
      .cai-ts-note b { font-weight: 700; color: #2F3A1C; }
      .cai-ts-note-dot { flex-shrink: 0; width: 8px; height: 8px; border-radius: 50%; background: #5E6B39; display: block; margin-top: 8px; }
      @media (max-width: 1040px) { .cai-ts-grid { grid-template-columns: 1fr 1fr; } }
      @media (max-width: 900px) { .cai-ts { padding: 64px 22px 64px; } .cai-ts-h2 { font-size: 32px; } .cai-ts-note { padding: 18px 20px; font-size: 15px; } }
      @media (max-width: 560px) { .cai-ts-grid { grid-template-columns: 1fr; } }
    `}</style>
  </section>
);

export default TechStack;
